/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --color: var(--nve-sys-layer-canvas-color);
  --padding: var(--nve-ref-size-200) var(--nve-ref-size-300);
  position: absolute;
  inset: var(--nve-ref-size-700) 0 0;
}

[internal-host] {
  background: color-mix(
    in oklab,
    var(--background, var(--nve-sys-layer-canvas-background)) 100%,
    var(--nve-sys-interaction-state-mix) var(--interaction-state-ratio, 0.01%)
  );
  color: var(--color);
  padding: var(--padding);
  font-size: var(--font-size);
  display: flex;
  place-items: center;
  place-content: center;
  height: 100%;
}
